import { __assign } from "tslib";
import { getErrorHandler } from '@office-start/error-handler';
import { KnownInstrumentationEvents, } from '@office-start/instrumentation-types';
import { appendQuery } from '@office-start/url-parser-utility';
import { httpPut } from '@office-start/xhr-service';
import { logUploadFeature } from '../utilities/logUploadFeature';
export function uploadFragment(graphXhrOptions, sessionUrl, startByte, endByte, fileSize, content, sessionId, onUploadProgress) {
    // Upload API issues a tempauth token in the query string parameter, which can only be used if URL matches "...uploadSession?guid=<guid>..."
    // In order to get the canonical URL, we would then have to append "select=webDavUrl,*" as a parameter towards the end. Subsequent requests to
    // the API would then automatically contain the QS param as well.
    var selectQuery = 'select=webDavUrl,*';
    if (!sessionUrl.endsWith(selectQuery)) {
        sessionUrl = appendQuery(sessionUrl, selectQuery);
    }
    var contentLength = Math.max(0, endByte - startByte);
    var requestConfig = {
        headers: {
            'Content-Range': "bytes ".concat(startByte, "-").concat(startByte + contentLength - 1, "/").concat(fileSize),
        },
    };
    return httpPut(KnownInstrumentationEvents.OneDriveGraphUploadFragmentRequest, "OneDrive_Graph_Upload_Fragment" /* KnownRequestInstrumentationEvents.OneDriveGraphUploadFragmentRequest */, sessionUrl, content, requestConfig, graphXhrOptions.jwtAuthEnabled, graphXhrOptions.getAccessToken, graphXhrOptions.officeApiRoot, graphXhrOptions.correlationId, 'None', {
        onUploadProgress: onUploadProgress,
        populateRequestEvent: function (response, params) {
            var otelParams = __assign({}, params);
            otelParams["TotalSize" /* InstrumentationParam.TotalSize */] =
                fileSize.toString();
            otelParams["ActualSize" /* InstrumentationParam.ActualSize */] =
                contentLength.toString();
            otelParams["Index" /* InstrumentationParam.Index */] = startByte.toString();
            logUploadFeature("OneDrive_Graph_Upload_Fragment" /* KnownRequestInstrumentationEvents.OneDriveGraphUploadFragmentRequest */, sessionId, response, otelParams);
        },
    })
        .then(function (response) {
        return response.data;
    })
        .catch(function (error) {
        getErrorHandler().handleError(error, "t59Ym" /* ErrorId.t59Ym */);
        throw error;
    });
}
//# sourceMappingURL=uploadFragment.js.map